"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _schemas = _interopRequireDefault(require("./schemas"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ComponentDataParser = /*#__PURE__*/function () {
  function ComponentDataParser(component, componentName, schemaData) {
    _classCallCheck(this, ComponentDataParser);

    this.component = component;
    this.componentName = componentName;
    this.schemaData = schemaData;
  }

  _createClass(ComponentDataParser, [{
    key: "getComponentData",
    value: function getComponentData() {
      var schema = this.schemaData || _schemas["default"][this.componentName].data;
      var data = {};

      for (var key in schema) {
        if ({}.hasOwnProperty.call(schema, key)) {
          var _schema$key = schema[key],
              name = _schema$key.name,
              element = _schema$key.element,
              type = _schema$key.type;
          var selectedElement = this.component.querySelector(element);
          var elementData = void 0;

          if (selectedElement !== null && selectedElement !== undefined) {
            elementData = ComponentDataParser.getElementDataByType(type, selectedElement);
          } else {
            elementData = null;
          }

          data[name] = elementData;
        }
      }

      return data;
    }
  }], [{
    key: "getElementDataByType",
    value: function getElementDataByType(type, element) {
      var typesMap = {
        image: ComponentDataParser.getComponentImage,
        mobileImage: ComponentDataParser.getComponentMobileImage,
        video: ComponentDataParser.getComponentVideo,
        iFrame: ComponentDataParser.getComponentIframe,
        html: ComponentDataParser.getComponentHtml,
        link: ComponentDataParser.getComponentLink,
        list: ComponentDataParser.getComponentList,
        text: ComponentDataParser.getComponentText,
        screeningTestList: ComponentDataParser.getComponentScreeningTestList,
        imageSpotList: ComponentDataParser.getComponentImageSpotList,
        newsListSpot: ComponentDataParser.getComponentNewsListSpot,
        linkList: ComponentDataParser.getComponentLinkList,
        languagesList: ComponentDataParser.getComponentLanguagesList,
        search: ComponentDataParser.getComponentSearch,
        headerContent: ComponentDataParser.getComponentHeaderContent,
        blogCategories: ComponentDataParser.getComponentBlogCategories,
        blogList: ComponentDataParser.getComponentBlogList,
        relatedList: ComponentDataParser.getComponentRelatedList,
        authorRelatedBlogs: ComponentDataParser.getComponentRelatedBlogs,
        navigation: ComponentDataParser.getComponentHeaderNavigation,
        searchFieldSpot: ComponentDataParser.getComponentSeachFieldSpot,
        languageSelectorSpot: ComponentDataParser.getComponentLanguageSelectorSpot
      };
      return typesMap[type](element);
    }
  }, {
    key: "getComponentImage",
    value: function getComponentImage(image) {
      if (typeof image.src !== "undefined") {
        return {
          image: image,
          src: image.src,
          alt: image.alt || null,
          height: image.height || null,
          width: image.width || null
        };
      }

      return {
        src: null,
        alt: null,
        height: null,
        width: null
      };
    }
  }, {
    key: "getComponentMobileImage",
    value: function getComponentMobileImage(mobileImage) {
      if (typeof mobileImage.dataset.mobileImage !== "undefined") {
        return {
          src: mobileImage.dataset.mobileImage,
          alt: mobileImage.dataset.mobileImageAltText || null,
          height: mobileImage.dataset.mobileImageHeight || null,
          width: mobileImage.dataset.mobileImageWidth || null
        };
      }

      return {
        src: null,
        alt: null,
        height: null,
        width: null
      };
    }
  }, {
    key: "getComponentVideo",
    value: function getComponentVideo(video) {
      if (typeof video.src !== "undefined") {
        return {
          src: video.src,
          type: video.type || null
        };
      }

      return {
        src: null,
        type: null
      };
    }
  }, {
    key: "getComponentIframe",
    value: function getComponentIframe(iframe) {
      if (typeof iframe.src !== "undefined") {
        return {
          src: iframe.src,
          width: iframe.width || null,
          height: iframe.height || null,
          frameBorder: iframe.frameborder || null
        };
      }

      return {
        src: null,
        width: null,
        height: null,
        frameBorder: null
      };
    }
  }, {
    key: "getComponentHtml",
    value: function getComponentHtml(html) {
      return {
        html: html.innerHTML || null
      };
    }
  }, {
    key: "getComponentLink",
    value: function getComponentLink(link) {
      return {
        href: link.href || null,
        content: link.innerHTML || null,
        target: link.target || null,
        title: link.title || null
      };
    }
  }, {
    key: "getComponentSeachFieldSpot",
    value: function getComponentSeachFieldSpot(spot) {
      return {
        resultPage: spot.getAttribute("data-result-page"),
        restrictedChars: spot.getAttribute("data-restricted-chars")
      };
    }
  }, {
    key: "getComponentList",
    value: function getComponentList(list) {
      var listElements = list.querySelectorAll("ul,ol")[0];

      if (listElements !== undefined) {
        var elements = [];
        [].forEach.call(listElements.children, function (el) {
          elements.push(el.innerHTML);
        });
        return elements;
      }

      return null;
    }
  }, {
    key: "getComponentText",
    value: function getComponentText(element) {
      return {
        text: element.innerText || null
      };
    }
  }, {
    key: "getComponentScreeningTestList",
    value: function getComponentScreeningTestList(list) {
      var listElements = list.querySelectorAll(".questions ul")[0];
      var questionsAndResults = {
        questions: [],
        results: []
      };

      if (listElements !== undefined) {
        [].forEach.call(listElements.children, function (el) {
          if (el.classList.contains("screening-test-result-container")) {
            var resultsList = el.querySelectorAll(".screening-test-result");
            [].forEach.call(resultsList, function (result) {
              questionsAndResults.results.push({
                title: result.querySelector("h2").innerText,
                description: result.querySelector(".result-description").innerHTML,
                minValue: result.dataset.minScore,
                maxValue: result.dataset.maxScore
              });
            });
          } else {
            var question = {
              title: el.querySelector("h2").innerText,
              description: el.querySelector(".question-description").innerHTML,
              answers: []
            };
            var questionAnswers = el.querySelectorAll(".button");
            [].forEach.call(questionAnswers, function (answer) {
              question.answers.push({
                title: answer.innerText,
                value: answer.dataset.score
              });
            });
            questionsAndResults.questions.push(question);
          }
        });
      }

      return questionsAndResults;
    }
  }, {
    key: "getComponentImageSpotList",
    value: function getComponentImageSpotList(list) {
      var listElements = list.querySelectorAll("li");
      var imageSpots = [];
      listElements.forEach(function (el) {
        var image = el.querySelector(".image-spot-element-image img");
        var imageDescription = el.querySelector(".image-spot-element-image-description");
        var header = el.querySelector(".image-spot-element-header");
        var text = el.querySelector(".image-spot-element-text");
        var contextContent = el.querySelector(".image-spot-element-context-content");
        var link = el.querySelector(".image-spot-element-link a");
        var sitecoreItem = el.querySelector('div[sc_item]');
        var sitecoreChromeData = el.querySelector('.scChromeData');
        var spot = {
          image: image === null ? null : ComponentDataParser.getComponentImage(image),
          imageDescription: imageDescription === null ? null : imageDescription.innerText,
          header: header === null ? null : header.innerHTML,
          text: text === null ? null : text.innerHTML,
          contextContent: contextContent === null ? null : contextContent.innerHTML,
          link: link === null ? null : ComponentDataParser.getComponentLink(link),
          sitecoreItem: sitecoreItem === null ? null : sitecoreItem.getAttribute('sc_item'),
          sitecoreChromeData: sitecoreChromeData === null ? null : sitecoreChromeData.textContent
        };
        imageSpots.push(spot);
      });
      return imageSpots;
    }
  }, {
    key: "getComponentNewsListSpot",
    value: function getComponentNewsListSpot(newsListSpot) {
      var listElements = newsListSpot.querySelectorAll("li");
      var elements = [];
      listElements.forEach(function (li) {
        var image = li.querySelector(".news-image img");
        var header = li.querySelector(".news-header").innerHTML;
        var location = li.querySelector(".news-location").innerHTML;
        var date = li.querySelector(".news-date h4").innerHTML;
        var text = li.querySelector(".news-text").innerHTML;
        var link = li.querySelector(".news-link a");
        elements.push({
          image: image,
          header: header,
          location: location,
          date: date,
          text: text,
          link: link
        });
      });
      return elements;
    }
  }, {
    key: "getComponentLinkList",
    value: function getComponentLinkList(linkList) {
      var listElements = linkList.querySelectorAll("li");
      var elements = [];
      listElements.forEach(function (li) {
        var link = li.querySelector("a");
        elements.push({
          link: link
        });
      });
      return elements;
    }
  }, {
    key: "getComponentBlogCategories",
    value: function getComponentBlogCategories(blogCategories) {
      var listElements = blogCategories.querySelectorAll("a");
      var elements = [];
      listElements.forEach(function (el) {
        var link = ComponentDataParser.getComponentLink(el);
        elements.push({
          link: link
        });
      });
      return elements;
    }
  }, {
    key: "getComponentBlogList",
    value: function getComponentBlogList(blogList) {
      var listElements = blogList.querySelectorAll("li");
      var elements = [];
      listElements.forEach(function (li) {
        var image = li.querySelector(".news-image img") || null;
        var title = li.querySelector(".news-title .link").innerHTML || null;
        var text = li.querySelector(".news-text").innerHTML || null;
        var date = li.querySelector(".news-date");
        if (date !== null) date = date.innerHTML;
        var link = li.querySelector("a") || null;
        var newsLink = li.querySelector(".news-link .link").innerHTML || null;
        elements.push({
          image: image,
          title: title,
          text: text,
          date: date,
          link: link,
          newsLink: newsLink
        });
      });
      return elements;
    }
  }, {
    key: "getComponentRelatedList",
    value: function getComponentRelatedList(relatedList) {
      var relatedElements = relatedList.querySelectorAll("li");
      var elements = [];
      relatedElements.forEach(function (li) {
        var image = li.querySelector(".news-image img");
        var date = li.querySelector(".news-date").innerHTML;
        var title = li.querySelector(".news-title").innerHTML;
        var text = li.querySelector(".news-text").innerHTML;
        var link = li.querySelector("a");
        var newsLink = li.querySelector(".news-link .link").innerHTML;
        elements.push({
          image: image,
          date: date,
          title: title,
          text: text,
          link: link,
          newsLink: newsLink
        });
      });
      return elements;
    }
  }, {
    key: "getComponentRelatedBlogs",
    value: function getComponentRelatedBlogs(authorRelatedBlogs) {
      var relatedElements = authorRelatedBlogs.querySelectorAll("li");
      var elements = [];
      relatedElements.forEach(function (li) {
        var image = li.querySelector(".author-blog-image img");
        var date = li.querySelector(".author-blog-date").innerHTML;
        var title = li.querySelector(".author-blog-title").innerHTML;
        var text = li.querySelector(".author-blog-text").innerHTML;
        var link = li.querySelector("a");
        var newsLink = li.querySelector(".author-blog-link .link").innerHTML;
        elements.push({
          image: image,
          date: date,
          title: title,
          text: text,
          link: link,
          newsLink: newsLink
        });
      });
      return elements;
    }
  }, {
    key: "getComponentLanguageSelectorSpot",
    value: function getComponentLanguageSelectorSpot(spot) {
      var languagesList = ComponentDataParser.getComponentLanguagesList(spot.querySelector('.component-content > ul'));
      var popupHeadline = ComponentDataParser.getComponentText(spot.querySelector('.component-content .popup__headline'));
      var popupLinks = [];
      spot.querySelectorAll('.component-content .popup__link').forEach(function (link) {
        popupLinks.push(ComponentDataParser.getComponentLink(link));
      });
      var prompt = !!spot.getAttribute('data-prompt');
      return {
        languagesList: languagesList,
        popupHeadline: popupHeadline,
        popupLinks: popupLinks,
        prompt: prompt
      };
    }
  }, {
    key: "getComponentLanguagesList",
    value: function getComponentLanguagesList(list) {
      var listElements = list.querySelectorAll("li");
      var languagesList = [];
      listElements.forEach(function (el) {
        var linkElement = el.querySelector("a");
        var link = ComponentDataParser.getComponentLink(linkElement);
        languagesList.push(link);
      });
      return languagesList;
    }
  }, {
    key: "getComponentSearch",
    value: function getComponentSearch(element) {
      return {
        searchUrl: element.dataset.resultPage || null
      };
    }
  }, {
    key: "getComponentHeaderContent",
    value: function getComponentHeaderContent(element) {
      var excludedClasses = ["image", "search-field-spot", "language-selector-spot", "nav-expander"];
      var includedClasses = ["link", "rich-text", "navigation"];
      var regexClasses = "\\b(".concat(excludedClasses.join("|"), ")\\b");
      var regex = new RegExp(regexClasses, "i");
      var components = element.querySelectorAll(".component");
      var content = [];
      components.forEach(function (com) {
        if (!regex.test(com.classList)) {
          includedClasses.forEach(function (ic) {
            if (com.classList.contains(ic)) {
              var componentData = null;

              switch (ic) {
                case "link":
                  {
                    var linkSelector = com.querySelector(".component-content a");
                    var btnClassList = com.classList.value;
                    componentData = ComponentDataParser.getComponentLink(linkSelector);
                    componentData.type = "link";

                    if (btnClassList !== null && btnClassList !== undefined) {
                      var btnMatch = btnClassList.match(/(header-btn-+\w+)/g);

                      if (btnMatch !== null) {
                        componentData.btnList = btnMatch.toString();
                      }
                    }

                    break;
                  }

                case "rich-text":
                  {
                    var rteSelector = com.querySelector(".component-content");
                    var linkClassList = com.classList.value;
                    componentData = ComponentDataParser.getComponentHtml(rteSelector);
                    componentData.type = "rich-text";

                    if (linkClassList !== null && linkClassList !== undefined) {
                      var listMatch = linkClassList.match(/(\w+-header)/g);

                      if (listMatch !== null) {
                        componentData.linkList = listMatch.toString();
                      }
                    }

                    break;
                  }

                case "navigation":
                  {
                    var navSelector = com.querySelector(".component-content ul");
                    componentData = ComponentDataParser.getComponentHeaderNavigation(navSelector);
                    componentData.type = "navigation";
                    break;
                  }

                default:
                  break;
              }

              content.push(componentData);
            }
          });
        }
      });
      return content;
    }
  }, {
    key: "getComponentHeaderNavigation",
    value: function getComponentHeaderNavigation(navigation) {
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var hookClass = ".level".concat(i);
      var currentNode = navigation.querySelectorAll("li".concat(hookClass));
      var globalNav = [];
      i += 1;
      currentNode.forEach(function (node) {
        var nav = {
          link: null,
          nestedLinks: []
        };
        var link = node.querySelector("li".concat(hookClass, " > a"));
        var nestedLinksUl = node.querySelector("li".concat(hookClass, " > ul"));
        nav.link = ComponentDataParser.getComponentLink(link);
        nav.nestedLinks = nestedLinksUl ? ComponentDataParser.getComponentHeaderNavigation(nestedLinksUl, i) : [];
        globalNav.push(nav);
      });
      return globalNav;
    }
  }]);

  return ComponentDataParser;
}();

var _default = ComponentDataParser;
exports["default"] = _default;